export enum CompetitionClassType {
    SingleEventSolo,
    SingleEventTeam,
    MultiEventSolo,
    MultiEventTeam
}

export enum Results2ScoreMethod {
    SingleSolo_Time,
    SingleSolo_Cascade_WorldCup,
    SingleSolo_Cascade_Scottish1k,
    SingleSolo_ScoreO,
    SingleSolo_ScoreO_Cascade_Scottish1k,
    SingleTeam_Cascade_WorldCup,
    ManySolo_Cascade_WorldCup,
    ManyTeam_Cascade_WorldCup
}